import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

/** Label/value pair for the metadata strips under detail-page titles. Render inside a `<dl>`. */
export function AdminMetaItem({
  label,
  className,
  children,
}: {
  label: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={cn('min-w-0', className)}>
      <dt className="text-[11px] font-medium uppercase tracking-wider text-muted-foreground">{label}</dt>
      <dd className="mt-1 truncate text-sm text-foreground">{children}</dd>
    </div>
  );
}
